import tinycolor from 'tinycolor2';

// Checks if a color is bright based on its brightness value
const isBrightColor = (color: tinycolor.Instance): boolean => {
  return color.getBrightness() > 180; // Adjust the threshold as needed
};

// Determines the most readable color on a given background
export const readableColorOnBackground = (background: string): string => {
  const bg = tinycolor(background);
  const white = tinycolor('#fff');
  const darkColor = bg.clone().darken(70);

  // Prefer darkColor for bright colors
  if (isBrightColor(bg)) {
    return darkColor.toHexString();
  }

  return tinycolor.mostReadable(bg.clone().darken(27), [darkColor, white]).toHexString();
};

export const getReadableColorOnWhite = (color: string): string => {
  const readableColor = readableColorOnBackground(color);
  const isMostReadable =
    tinycolor.readability(color, '#fff') > tinycolor.readability(readableColor, '#fff');
  return isMostReadable ? color : readableColor;
};

export const colorWithAlpha = (
  primary: string,
  alpha = 0.05,
  params?: {
    bgColor?: string;
    minLuminance?: number;
  }
): string => {
  const topRGB = tinycolor(primary).toRgb();
  const bottomRGB = params?.bgColor
    ? tinycolor(params.bgColor).toRgb()
    : tinycolor('#ffffff').toRgb();

  let color = tinycolor({
    r: alpha * topRGB.r + (1 - alpha) * bottomRGB.r,
    g: alpha * topRGB.g + (1 - alpha) * bottomRGB.g,
    b: alpha * topRGB.b + (1 - alpha) * bottomRGB.b,
    a: 0,
  });

  const lum = color.getLuminance();
  if (params?.minLuminance && params.minLuminance > lum) {
    color = color.lighten((params.minLuminance - lum) * 100);
  }

  return color.toHexString();
};

export const getOpacity = (color: string): number => {
  return tinycolor(color).getAlpha() * 100;
};

export const colorWithOpacity = (color: string, alpha: number): string => {
  return tinycolor(color).setAlpha(alpha).toRgbString();
};
